import { LightningElement } from 'lwc';
import { isIISEventListenerEnabled } from '../../../shared/feature';

declare global {
  interface DocumentEventMap {
    'tbid_auth_event': IISEvent;
  }
}

interface IISEventDetail {
  meta?: {
    eventName?: 'onLogin' | 'onLogout' | 'onUpdate';
  };
}

interface IISEvent extends CustomEvent {
  detail: IISEventDetail;
}

export default class IISEventListener extends LightningElement {
  private _handler: ((event: IISEvent) => void) | null = null;

  async connectedCallback() {
    this.manageIISEventListener();
  }

  disconnectedCallback() {
    this.removeIISEventListener();
  }

  private manageIISEventListener() {
    if (isIISEventListenerEnabled()) {
      this.addIISEventListener();
    } else {
      this.removeIISEventListener();
    }
  }

  private addIISEventListener() {
    if (!this._handler) {
      this._handler = this.handleIISEvent.bind(this);
      window.document.addEventListener('tbid_auth_event', this._handler);
    }
  }

  private removeIISEventListener() {
    if (this._handler) {
      window.document.removeEventListener('tbid_auth_event', this._handler);
      this._handler = null;
    }
  }

  handleIISEvent(event: IISEvent) {
    const IISEventName = event.detail?.meta?.eventName;

    if (
      IISEventName === 'onLogin' ||
      IISEventName === 'onLogout' ||
      IISEventName === 'onUpdate'
    ) {
      this.dispatchEvent(
        new CustomEvent('iischange', {
          detail: {
            action: IISEventName,
          },
        })
      );
    }
  }
}
